export enum ActingOnBehalfKontoStatusEnum {
  AKTIV = 'AKTIV',
  INAKTIV = 'INAKTIV',
  RUHEND = 'RUHEND',
  GESPERRT = 'GESPERRT',
  ARCHIVIERT = 'ARCHIVIERT',
  UNBEKANNT = 'UNBEKANNT'
}
